import React from 'react';
import './SearchInput.css';

export default function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
  ...props
}) {
  return (
    <div className={`search-input-wrapper ${className}`}>
      <svg className="search-icon" viewBox="0 0 20 20" fill="none">
        <path
          d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16ZM18 18l-4.35-4.35"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <input
        type="text"
        className="search-input"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...props}
      />
      {value && (
        <button
          className="search-clear"
          onClick={() => onChange({ target: { value: '' } })}
          aria-label="Clear search"
        >
          ×
        </button>
      )}
    </div>
  );
}


